module.exports = __webpack_public_path__ + "static/img/Visualization1.99499261.png";